import React from 'react'
import CognitoUserDetail from './abstract/CognitoUserDetail'
import CompanyUserList from './CompanyUserList'
import StyleAdmin from '../../style/StyleAdmin'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'

class CompanyDetail extends CognitoUserDetail {
  constructor (props) {
    super(props)
    this.state = {userDetail: '', temporaryPassword: ''}
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '企業'
    this.userRoleUrl = 'company'
    this.userRole = 'companyAdmin'
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const temporaryPassword = queryParams.get('temporaryPassword');
    
    if (temporaryPassword) {
      this.setState({ temporaryPassword });
    }
  }
  onCompanyUserCreateClick () {
    this.props.history.push('/admin/company_user/add/' + this.state.userDetail.id)
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const userDetail = this.renderUserDetail(this.userRoleName + '管理者情報', '企業名', this.state.userDetail, this.state.temporaryPassword)
    const disableButton = (<li key='disable' className='kw-btn-area'><button id='suspend-button' rel='tooltip' title='一時無効' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('disable', e)} ><i className='icon-eye-close icon-large' /><span>一時<br />無効</span></button></li>)
    const enableButton = (<li key='enable' className='kw-btn-area'><button id='resurrection-button' rel='tooltip' title='復活' data-placement='bottom' className='kw-btn-info' onClick={(e) => this.onPageMenuClicked('enable', e)} ><i className='icon-heart-empty icon-large' /><span>復活</span></button></li>)
    const disableOrEnable = this.state.userDetail.enabled ? disableButton : enableButton
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報 - 詳細<br /><small>こちらで{this.userRoleName}の情報を参照できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back', e)} ><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                  <li className='kw-btn-area'><button id='edit-button' rel='tooltip' title='編集' data-placement='bottom' className='kw-btn-success' onClick={(e) => this.onPageMenuClicked('edit', e)} ><i className='icon-edit icon-large' /><span>編集</span></button></li>
                  <li key='ban' className='kw-btn-area'><button id='delete-button' rel='tooltip' title='削除' data-placement='bottom' className='kw-btn-danger' onClick={(e) => this.onPageMenuClicked('ban', e)} ><i className='icon-remove icon-large' /><span>削除</span></button></li>
                  {disableOrEnable}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container form-horizontal'>
          <div className='row'>
            {userDetail}
          </div>
        </section>
        <section className='page container'>
          <div className='text-right'>
            <a rel='tooltip' data-placement='left' title='新規の会員企業ユーザを登録' className='text-center kw-btn-primary' onClick={(e) => this.onCompanyUserCreateClick(e)}>
              <button type='button' className='btn btn-info' style={StyleAdmin.companyDetail.addButton.bottomSpace}><i className='icon-plus icon-large' /><br /><span>新規</span></button>
            </a>
          </div>
          <CompanyUserList parentID={this.state.userDetail.id} history={this.props.history} />
        </section>
      </div>
    )
  }
}

export default CompanyDetail



// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyDetail.js